import {createApp} from 'vue'
import options from './TextEditor.options'

const el = '.kb-component--text-editor'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((TextEditorDOM)=>{
            const props = {
                initContent: TextEditorDOM.dataset.content
            }
            const template = TextEditorDOM.outerHTML.replace(/(<editor\s)/gi, '<editor v-if="editorReady" ')
            options.template = template
            const component = createApp(options, props).use(Store)
            component.mount(TextEditorDOM)
        })
    }
}

